// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"07331429","63":"115d8b9b","136":"8dc86cb3","469":"0a66a121","577":"9f57fc1f","703":"94161e60","711":"1dd5230f","780":"196bfd95","949":"c9b5a702","966":"852278a8","996":"238d2355"}[chunkId] + ".chunk.js";
};